export const MAIN_THEME_COLOR = "#40A2E3";
export const SECONDARY_THEME_COLOR = "#77C3EC";
